// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GIzD1","colMin":"styles_colMin__Y7WBf"};